import classNames from "classnames";
import AscButton from "../AscButton/AscButton";
import { ChallengeTopListBannerIllustration } from "../AscIllustrations";
import AscLink from "../AscLink/AscLink";
import AscModal from "../AscModal/AscModal";
import AscHeading from "../AscTypography/AscHeading/AscHeading";
import styles from "./AscChallengeTopListModal.module.scss";

export interface AscChallengeTopListModalProps {
  className?: string;
  visible: boolean;
  setVisible: (visible: boolean) => void;
  title: string;
  description: string;
  descriptionPoints: string[];
  challengesPath: string;
}

export default function AscChallengeTopListModal({
  className,
  visible,
  setVisible,
  title,
  description,
  descriptionPoints,
  challengesPath,
}: AscChallengeTopListModalProps) {
  return (
    <AscModal
      data-testid="asc-challenge-top-list-modal"
      modalClassName={classNames(styles.ground, className)}
      visible={visible}
      setVisible={setVisible}
      headerClassName={styles.headerClassName}
      header={
        <ChallengeTopListBannerIllustration className={styles.illustration} />
      }
      innerContentClassName={styles.modalContent}
      withBackground={false}
    >
      <AscHeading className={styles.title}>{title}</AscHeading>
      <p
        className={styles.description}
        dangerouslySetInnerHTML={{
          __html: description,
        }}
      />
      <ul className={styles.pointsList}>
        {descriptionPoints?.map((point, index) => (
          <li key={index} className={styles.pointItem}>
            <span className={styles.pointIndex}>{index + 1}</span>
            <span className={styles.pointText}>{point}</span>
          </li>
        ))}
      </ul>
      <AscLink
        href={challengesPath}
        innerWrapperTag={null}
        className={styles.buttonLinkWrapper}
      >
        <AscButton size="large" narrowPadding fullWidth>
          Go to Challenges
        </AscButton>
      </AscLink>
    </AscModal>
  );
}
